import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const loadStaticDataBusinessGroups = createAction(
  '[StaticData] Load BusinessGroups',
  props<{ businessId: string, noLoader: boolean}>(),
  );

export const loadStaticDataBusinessGroupsSuccess = createAction(
  '[StaticData] Load BusinessGroups Success',
  props<{ response: IStaticDataResponse[] }>()
);

export const loadStaticDataBusinessGroupsFailure = createAction(
  '[StaticData] Load BusinessGroups Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
